import { render, staticRenderFns } from "./DmKalkulator.vue?vue&type=template&id=542c1e98&scoped=true&"
import script from "./DmKalkulator.vue?vue&type=script&lang=js&"
export * from "./DmKalkulator.vue?vue&type=script&lang=js&"
import style0 from "./DmKalkulator.vue?vue&type=style&index=0&id=542c1e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c1e98",
  null
  
)

export default component.exports